import { createContext, useContext, useMemo, useState } from 'react';
import type { ReactNode } from 'react';

type AvailabilityPopoverContextValue = {
  activeId: string | null;
  setActiveId: (id: string | null) => void;
};

const AvailabilityPopoverContext =
  createContext<AvailabilityPopoverContextValue | null>(null);

export const AvailabilityPopoverProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const value = useMemo(() => ({ activeId, setActiveId }), [activeId]);

  return (
    <AvailabilityPopoverContext.Provider value={value}>
      {children}
    </AvailabilityPopoverContext.Provider>
  );
};

export const useAvailabilityPopoverGroup = () => {
  const context = useContext(AvailabilityPopoverContext);

  if (!context) {
    throw new Error(
      'useAvailabilityPopoverGroup must be used within an AvailabilityPopoverProvider'
    );
  }

  return context;
};
